export default __webpack_public_path__ + "static/hitech-kyc-fin-ffe8e0a2aef5da473f785578f4dd9f28.png";